import { DEFAULT_QUANTIFY_SORT_BY_FOR_TOP_SELECTION } from '@modules/quantify/constants';
import { QuantifyReportDataPoint, SortBy } from '@modules/quantify/store/types';

interface GetDefaultSortByOptions {
  records: QuantifyReportDataPoint[];
  shouldShowAnomalies: boolean;
}

export const getDefaultSortByForTopSelection = ({
  records,
  shouldShowAnomalies,
}: GetDefaultSortByOptions): SortBy => {
  if (shouldShowAnomalies) {
    const anomalousDataPoint = records.find(
      (dataPoint) => dataPoint.isAnomalous,
    );
    const anomalousTimestampVariant = anomalousDataPoint?.variants
      ? Object.values(anomalousDataPoint.variants)?.find(
          (variant) => !!variant.anomalyValue,
        )
      : null;

    return anomalousTimestampVariant
      ? {
          field: anomalousTimestampVariant.id,
          isAsc: false,
        }
      : DEFAULT_QUANTIFY_SORT_BY_FOR_TOP_SELECTION;
  }

  return DEFAULT_QUANTIFY_SORT_BY_FOR_TOP_SELECTION;
};
